import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
window.UEDITOR_HOME_URL = "/static/ueditor/";
// 导入样式
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './index.css'
import './element-variable.scss'
// 引入富文本编辑器
// import '../public/tinymce/tinymce.js'
// Vue.component('vue-ueditor-wrap', VueUeditorWrap)
// 引入echarts
import * as echarts from 'echarts'
// 使用echarts
Vue.prototype.$echarts = echarts
// 使用axios
Vue.prototype.axios = axios

Vue.use(ElementUI)

Vue.config.productionTip = false

// //创建vue空实例
// let hub = new Vue()
// Vue.prototype.$eventhande = hub //加入vue原型中，让所有组件可以访问到该对象

new Vue({
  router,
  // store,
  // Axios,
  render: h => h(App),
}).$mount('#app')
